import React, { useEffect, useRef, useState } from "react";
import { useI18next } from "../../../../plugins/gatsby-plugin-ap-i18next/src/useI18next";
import { RouteComponentProps } from "@reach/router";
import { navigate } from "gatsby";
import { useDispatch, useSelector } from "react-redux";

import {
    container,
    section,
    content,
    text,
    titleSvg,
    header,
    list,
    item,
    card,
    error,
    sharebuttons,
    shareallbutton,
    shareWrapper,
    stylizationHeader,
    postTitles,
    tryOnButton,
    buttonsWrapper,
    virtualTryOnContainer,
    virtualTryOnContainerImage,
    productCardMinimal,
    buttonContent
} from "./stylization-view.module.scss";
import { mainGrid } from "../../../styles/grid.module.scss";
import Congratulation from "../../../assets/images/svg/success.svg";
import ShareIcon from "../../../assets/images/svg/share.svg";
import ImageIcon from "../../../assets/images/svg/imageDownload.svg";
import { IStylization } from "../../../models/stylization.model";
import { TStatus } from "../../../models/status.model";
import { getAbsolutePath } from "../../utility/routes.utility";
import getNodes from "../../../utils/get-nodes";
import getPostsWithAuthor from "../../../utils/get-posts-with-author";
import {
    selectSingleStylization,
    selectSingleStylizationStatus,
} from "../../../redux/single-stylization/single-stylization.selectors";
import {
    clearSingleStylizationAction,
    getSingleStylizationAction,
} from "../../../redux/single-stylization/single-stylization.actions";

import { useStaticQuery, graphql } from "gatsby";
import { useLocation } from "@reach/router";

import {
    FacebookShareButton,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share";
import Section from "../../../components/molecules/section";
import Title from "../../../components/atoms/title";
import ProductCard from "../molecules/product-card";
import Button from "../../../components/atoms/button";
import Loader from "../../../components/atoms/loader";
import { Helmet } from "react-helmet";
import moment from "moment";
import WidgetBox from "../../../components/organisms/sections/common/widget-box";
import PostsSection from "../../../components/organisms/sections/posts-section";
import { IAuthor } from "../../../models/author.model";
import { IPostBrief } from "../../../models/post.model";
import { setAlert } from "../../../redux/alerts/alerts.actions";
import { USER } from "../../../redux/user/user.reducer";
import ButtonIcon from "../../../components/molecules/button-icon";
import { createVirtualTryOnAction } from "../../../redux/virtual-tryon/virtual-tryon.actions";
import { IVirtualTryOn } from "../../../models/virtualtryon.model";
import { selectVirtualTryOn } from "../../../redux/virtual-tryon/virtual-tryon.selectors";
import ImageUploader from "../../../components/molecules/image-uploader";
import { uploadFileToApi } from "../../../services/fileupload-services";
import useMediaQuery from "../../../hooks/use-media-query";
import { breakpoints } from "../../../config/breakpoints";
import ImageSliderSimple from "../../../components/organisms/image-slider-simple";

type TStylizationViewProps = {
    stylizationId?: number;
    guid: string;
    isCongratulationSite?: boolean;
    shareView?: boolean;
} & RouteComponentProps;

const customIconProps = {
    size: 40,
    bgStyle: {
        fill: "none",
    },
    iconFillColor: "black",
};

const StylizationView: React.FC<TStylizationViewProps> = ({
    stylizationId,
    guid,
    isCongratulationSite,
    shareView = false,
}) => {
    const { t } = useI18next();
    const dispatch = useDispatch();

    const { site, promotedPosts, authors } = useStaticQuery(query);

    const promotedPostsData = getNodes(promotedPosts);// as IPostBrief[];
    const authorsData = getNodes(authors);// as IAuthor[];
    const postsWithAuthor = getPostsWithAuthor(promotedPostsData, authorsData);
    const isTablet = useMediaQuery(breakpoints.tablet);

    const [shareUrl, setShareUrl] = useState('');


    const { pathname } = useLocation();


    const {
        url: siteUrl,
        shareApiUrl: shareApiUrl
    } = site.siteMetadata;

    const seo = {
        url: `${siteUrl}${pathname}`,
    };

    const stylization: IStylization | null = useSelector(selectSingleStylization);
    const status: TStatus = useSelector(selectSingleStylizationStatus);

    const { name, products = [], occasion } = stylization || {};

    const [tryOnView, setTryOnView] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadFile, setUploadFile] = useState<File | null>(null);
    const [isUploadPhotoButton, setIsUploadPhotoButton] = useState(false);
    const [virtalTryOnList, setVirtualTryOnList] = useState<string[]>([]);

    const isFirstRender = useRef(true);

    const virtualTryOnViewer: IVirtualTryOn = useSelector(selectVirtualTryOn);

    const handleReturn = () => {
        navigate(getAbsolutePath("ACCOUNT_STYLIZATIONS"));
    };

    const shareAll = async () => {
        const shareData = {
            title: "Fashionfairy stylizacja",
            text: "Zobacz jaką stylizację mi wyczarowali!",
            url: shareUrl,
        };
        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                console.error("Share failed:", err.message);
            }
        } else {
            // fallback – pokaż popup z linkiem
            navigator.clipboard.writeText(shareUrl);
            //alert(`Link został skopiowany do schowka: ${shareUrl}`);
            dispatch(setAlert({ type: "success", content: `Link został skopiowany do schowka.` }, { entity: USER }))
        }
    }

    useEffect(() => {
        console.log("stylizationId: ", stylizationId);
        console.log("stylization guid: ", guid);
        if (!stylizationId) return;
        dispatch(getSingleStylizationAction(stylizationId, guid));
        return () => {
            dispatch(clearSingleStylizationAction());
        };
    }, [dispatch, stylizationId, guid]);

    useEffect(() => {
        let share = shareApiUrl + "/stylization/view/" + stylizationId + "/" + stylization?.guid;
        console.log('share: ', share);
        setShareUrl(share);
        if (stylization && stylization?.isTryOnGenerated
            && !shareView
        ) {
            setTryOnView(true);
            dispatch(
                createVirtualTryOnAction({
                    guid: stylization?.guidSearch
                })
            );
        }
    }, [JSON.stringify(stylization)]);

    const downloadImage = async (url, filename = "image.jpg") => {
        const response = await fetch(url, { mode: "cors" });
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
    };

    const handleTryOnClick = () => {
        console.log("handleTryOnClick called: ", guid);
        console.log("stylization", stylization);
        setIsLoading(true);
        dispatch(
            createVirtualTryOnAction({
                guid: stylization?.guidSearch
            })
        );
    }

    useEffect(() => {
        console.log("!!!!virtualTryOnViewer: ", virtualTryOnViewer)
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return; // NIE wykonuj kodu przy pierwszym renderze
        }
        if (virtualTryOnViewer && virtualTryOnViewer.imageUrl) {
            setIsLoading(false);
            setTryOnView(true);
            const list = [virtualTryOnViewer.imageUrl1];
            if (virtualTryOnViewer.imageUrl2) {
                list.push(virtualTryOnViewer.imageUrl2);
            }
            setVirtualTryOnList(list);
        }
    }, [virtualTryOnViewer])

    const onUploadPhoto = (file: File) => {
        console.log("onUploadPhoto called: ", file);
        setUploadFile(file);
        setIsUploadPhotoButton(true);
    }
    const handleTryOnAndUploadClick = async () => {
        console.log("handleTryOnAndUploadClick called: ", stylization?.guidSearch);
        setIsLoading(true);

        var uploadResponse = await uploadFileToApi(uploadFile);

        setUploadFile(null);
        setIsUploadPhotoButton(false);
        dispatch(
            createVirtualTryOnAction({
                guid: stylization?.guidSearch
            })
        );
    }
    return (
        <>

            {shareView && <WidgetBox alwaysVisible={true} />}
            {isLoading && <Loader position="fixed" />}
            <div className={`${container} ${mainGrid}`}>
                <Section className={section}>
                    <div className={content}>
                        {(!status || status === "loading" || status === "idle") && (
                            <Loader position={"absolute"} />
                        )}
                        {status === "fail" && (
                            <p className={error}>{t("generator.stylization.fail")}</p>
                        )}
                        {status === "success" && stylization && (
                            <>

                                {isCongratulationSite ? (
                                    <div className={header}>
                                        <Congratulation className={titleSvg} />
                                        <h1 className={text}>{t("generator.stylization.ready")}</h1>
                                    </div>
                                ) : (
                                    <div className={stylizationHeader}>
                                        {occasion?.label}
                                    </div>
                                    // <Title
                                    //     Tag="h1"
                                    //     subtitle={""}
                                    //     align="center"
                                    //     fontStyle="italic"
                                    // >
                                    //     {occasion?.label}
                                    // </Title>
                                )}
                                <Helmet>
                                    <meta name="image" content={stylization.shareUrl} />
                                    <meta property="og:image" content={stylization.shareUrl} />
                                    <meta property="twitter:image" content={stylization.shareUrl} />
                                    <meta property="og:url" content={shareUrl} />
                                </Helmet>
                                {tryOnView && <div className={virtualTryOnContainer}>
                                    {virtualTryOnViewer && virtualTryOnViewer.status == 0 && <>
                                        <div className={virtualTryOnContainerImage}>
                                            {!isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <img src={virtualTryOnViewer.imageUrl}></img>}
                                            {isTablet && virtualTryOnViewer && virtualTryOnViewer.imageUrl && <div style={{ flex: '85%' }}><ImageSliderSimple products={virtalTryOnList} /></div>}
                                            <div className={list}>
                                                {products.map((product) => {
                                                    return (
                                                        <ProductCard isTablet={isTablet}
                                                            key={product.productId}
                                                            product={product}
                                                            isMinimal={true}
                                                            className={productCardMinimal}
                                                            classNameButtonContent={buttonContent}
                                                            productLength={products.length} />
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </>}
                                    {virtualTryOnViewer && virtualTryOnViewer.status == -1 && <>
                                        <ImageUploader onUploadPhoto={onUploadPhoto}></ImageUploader>
                                    </>}
                                </div>}
                                {!tryOnView && <ul className={list}>
                                    {products.map((product) => {
                                        return (
                                            <li key={product.productId} className={item}>
                                                <ProductCard isTablet={false} product={product} className={card} productLength={products.length} />

                                            </li>
                                        );
                                    })}
                                </ul>}
                                {!shareView && <div className={shareWrapper}>
                                    <p>Podziel się ze znajomymi:</p>
                                    <div className={sharebuttons}>
                                        <FacebookShareButton url={shareUrl}>
                                            <FacebookIcon {...customIconProps}></FacebookIcon>
                                        </FacebookShareButton>
                                        <TwitterShareButton url={shareUrl}>
                                            <TwitterIcon {...customIconProps} />
                                        </TwitterShareButton>
                                        <LinkedinShareButton url={shareUrl}>
                                            <LinkedinIcon {...customIconProps} />
                                        </LinkedinShareButton>
                                        <div className={shareallbutton}>
                                            <ImageIcon onClick={() => downloadImage(stylization.shareUrl, "stylizacja.jpg")}></ImageIcon>
                                        </div>
                                        <div className={shareallbutton}>
                                            <ShareIcon onClick={shareAll}></ShareIcon>
                                        </div>
                                    </div>
                                </div>}
                            </>
                        )}
                    </div>
                    {!shareView &&
                        <div className={buttonsWrapper}>
                            <Button onClick={handleReturn} type="filled">
                                {isCongratulationSite
                                    ? t(`generator.stylization.ready.button`)
                                    : t(`generator.stylization.view.button`)}
                            </Button>
                            {!tryOnView && <ButtonIcon withLink={false}
                                onClick={handleTryOnClick} htmlType="button" className={tryOnButton}
                                text={"Ubierz mnie!"}>
                            </ButtonIcon>}
                            {tryOnView && isUploadPhotoButton && <ButtonIcon withLink={false} onClick={handleTryOnAndUploadClick} htmlType="button" className={tryOnButton} text={"Ubierz mnie!"}>
                            </ButtonIcon>}
                        </div>}
                    {shareView}
                </Section>
            </div>
            {shareView && postsWithAuthor.length > 0 && (
                <>
                    <div className={postTitles}>
                        <h2>✨ Najnowsze artykuły</h2>
                    </div>
                    <PostsSection
                        posts={postsWithAuthor}
                        authors={authorsData}
                        titleKey="posts-section.title"
                        subtitleKey="common.blog"
                        showNew={true}
                    />
                </>
            )}
        </>
    );
};

const query = graphql`
    query {
        site {
            siteMetadata {
                title
                description
                image
                url
                shareApiUrl
            }
        }
        promotedPosts: allPost(sort: { fields: publishedAt, order: DESC }, limit: 4) {
            edges {
                node {
                    ...postBriefFields
                }
            }
        }

        authors: allAuthor {
            edges {
                node {
                    ...authorFields
                }
            }
        }
    }
`;
export default StylizationView;
